import * as type from '../types';


const initialState = {
    inSessionCollateralInformation: [],
    sessionDate: null,
    loading: false,
    error: false,
    currentBlockedPriceDetailList:[],
  };
  

  export default function inSessionCollateral(state = initialState, action) {
    switch (action.type) {
      case type.GET_SESSION_COLLATERAL_REQUESTED:
        return {
          ...state,
          loading: true,
          error: false,
        };
      case type.GET_SESSION_COLLATERAL_SUCCEEDED:
        return {
          ...state,
          inSessionCollateralInformation: action.payload,
          loading: false,
          error: false,
        };
      case type.GET_SESSION_COLLATERAL_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
        };
      case type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED:
        return {
            ...state,
           loading: true,
          error: false,
          };
       case type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_SUCCEEDED:
        return {
             ...state,
          currentBlockedPriceDetailList: action.payload?.item,
          loading: false,
          error: false,
          };
          case type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_FAILED:
        return {
           ...state,
          loading: false,
          error: true,
          };
      case type.GET_ALL_SESSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_ALL_SESSIONS_SUCCEEDED:
      return {
        ...state,
        allSessionList: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_ALL_SESSIONS_FAILED:
      return {
        ...state,
        allSessionList: [],
        loading: false,
        error: true,
      };
      default:
        return state;
    }
  }
  